/**
 * MarkdownContent — renders markdown text in chat messages.
 *
 * Used for system messages (/ping, /help) and any future markdown content.
 * Uses react-markdown with remark-gfm for tables, strikethrough, etc.
 */

import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownContentProps {
  content: string;
}

export function MarkdownContent({ content }: MarkdownContentProps) {
  return (
    <div className="chat-markdown">
      <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
    </div>
  );
}
